import type { UnionToTuple } from 'type-fest';

import { tuiPure } from '@taiga-ui/cdk';
import { chunk } from 'es-toolkit/array';

import type { PageLoadingOptions } from './page-loading.type';

export class PageLoadingKit<Params extends Record<string, unknown> = never> {
  document: Document;
  #app_preloader: HTMLDivElement;
  #isInit = false;
  #innerHTML: string;
  readonly #paramsKeys: UnionToTuple<keyof Params>;

  constructor(options: PageLoadingOptions<Params>) {
    const { innerHTML } = options;
    this.document = options.document ?? document;
    this.#app_preloader = this.document.createElement('div');
    this.#innerHTML = innerHTML;
    this.#paramsKeys = options.paramsKeys ?? [];
  }

  init(params?: Params) {
    if (this.#isInit) return;
    const div = this.#app_preloader;
    div.style.cssText = `position: fixed;
        top: 0;
        left: 0;
        z-index: 9999;
        width: 100%;
        height: 100%;
        overflow: hidden;
        transition: opacity 0.65s;`;
    div.id = '_page_loading_web_kit' + new Date().getTime();
    div.innerHTML = this.getInnerHTML(params);
    this.document.body.appendChild(div);
    this.#isInit = true;
  }
  show(params?: Params) {
    this.#app_preloader.innerHTML = this.getInnerHTML(params);
    this.#app_preloader.style.display = 'unset';
  }
  hide() {
    this.#app_preloader.style.display = 'none';
  }
  private getInnerHTML(params?: Params) {
    // console.log('getInnerHTML', params);
    const paramsList: unknown[] = [];
    if (params) {
      for (const key in params) {
        paramsList.push(key, params[key]);
      }
    }
    return this.getInnerHTMLPure(...paramsList);
  }
  @tuiPure
  private getInnerHTMLPure(...params: unknown[]) {
    // console.log('getInnerHTMLPure', params, params.length);
    let res = this.#innerHTML;
    const paramsMap = new Map(chunk(params, 2) as [unknown, unknown][]); // 使用es-toolkit的array.chunk
    this.#paramsKeys.forEach((key) => {
      let value = paramsMap.get(key);
      if (value == null || value === undefined) value = '';
      res = res.replace(`\${${key}}`, `${value}`);
    });
    return res;
  }
}
